module.exports = __webpack_public_path__ + "static/PaulDraws_Yarra-982c60ef69b08194f3bf628dc018b1d2.jpg";